import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Message, SpinnerService } from 'shared-components';
import { AdminService } from '../../../../../services/admin.service';
import { Subject } from "rxjs";

@Component({
    selector: 'app-new-edit-param-grupo-etiquetas-marca',
    templateUrl: './new-edit.component.html'
})
export class NewEditParamGrupoEtiquetasMarca implements OnInit {

    public newEditForm: UntypedFormGroup;
    public showError = false;
    public deleteModal = false;
    private _editable: boolean;
    public mensajes = new Array<Message>();
    public toCloseSpinner = 0;

    public allGrupoEtiquetasCaja;
    public allGrupoEtiquetasPallet;

    public grupoEtiquetaIdCaja;
    public grupoEtiquetaIdPallet;

    public disabledCaja: Subject<boolean> = new Subject();
    public disabledPallet: Subject<boolean> = new Subject();

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.newEditForm) {
            if (value) {
                this.newEditForm.enable();
                this.disabledCaja.next(false);
                this.disabledPallet.next(false);
            } else {
                this.newEditForm.disable();
                this.disabledCaja.next(true);
                this.disabledPallet.next(true);

                for (let grupoEtiquetaCaja of this.grupoEtiquetasCaja) {
                    if (grupoEtiquetaCaja.grupoEtiquetaId && grupoEtiquetaCaja.marcaId === this.marcaId) {
                        this.newEditForm.get('grupoEtiquetasCaja')
                        .patchValue(this.allGrupoEtiquetasCaja.find(x => x.id === grupoEtiquetaCaja.grupoEtiquetaId));
                        this.grupoEtiquetaIdCaja = grupoEtiquetaCaja.grupoEtiquetaId;
                    }
                }

                for (let grupoEtiquetaPallet of this.grupoEtiquetasPallet) {
                    if (grupoEtiquetaPallet.grupoEtiquetaId && grupoEtiquetaPallet.marcaId === this.marcaId) {
                        this.newEditForm.get('grupoEtiquetasPallet')
                        .patchValue(this.allGrupoEtiquetasPallet.find(x => x.id === grupoEtiquetaPallet.grupoEtiquetaId));
                        this.grupoEtiquetaIdPallet = grupoEtiquetaPallet.grupoEtiquetaId;
                    }
                }
            }
        }
    }
    @Input() grupoEtiquetasCaja;
    @Input() grupoEtiquetasPallet;
    @Input() marca;
    @Input() marcaId;
    @Input() licenciaSwId;
    @Input() almacenId;
    @Input() denominacionId;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() editableChanged = new EventEmitter<any>();
    @Output() pushMessage = new EventEmitter<string>();
    @Output() close = new EventEmitter<boolean>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _adminService: AdminService,
    ) { }

    ngOnInit() {
        this.newEditForm = this._fb.group({
            grupoEtiquetasCaja: [{ value: '', disabled: !this.editable }],
            grupoEtiquetasPallet: [{ value: '', disabled: !this.editable }]
        });

        const promises: Promise<any>[] = [];

        this._spinnerService.showSpinner();

        promises.push(
            this.getAllGruposEtiquetaCajas(),
            this.getAllGruposEtiquetaPallet()
        )

        Promise.all(promises).then(
            () => {
                for (let grupoEtiquetaCaja of this.grupoEtiquetasCaja) {
                    if (grupoEtiquetaCaja.grupoEtiquetaId && grupoEtiquetaCaja.marcaId === this.marcaId) {
                        this.newEditForm.get('grupoEtiquetasCaja')
                        .patchValue(this.allGrupoEtiquetasCaja.find(x => x.id === grupoEtiquetaCaja.grupoEtiquetaId));
                        this.grupoEtiquetaIdCaja = grupoEtiquetaCaja.grupoEtiquetaId;
                    }
                }

                for (let grupoEtiquetaPallet of this.grupoEtiquetasPallet) {
                    if (grupoEtiquetaPallet.grupoEtiquetaId && grupoEtiquetaPallet.marcaId === this.marcaId) {
                        this.newEditForm.get('grupoEtiquetasPallet')
                        .patchValue(this.allGrupoEtiquetasPallet.find(x => x.id === grupoEtiquetaPallet.grupoEtiquetaId));
                        this.grupoEtiquetaIdPallet = grupoEtiquetaPallet.grupoEtiquetaId;
                    }
                }
            }, (error) => {
                console.log('Promise rejected with ' + JSON.stringify(error));
            }
        ).catch(e => console.log(e));
    }

    public getAllGruposEtiquetaCajas(): Promise<any> {
        return new Promise((resolve, reject) => {
            let _filters = {
                tipoConfeccionId: 1
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._adminService.getGruposEtiqueta(_filters).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.lista.length > 0) {
                    this.allGrupoEtiquetasCaja = resp.lista;
                }
                setTimeout(resolve, 1);
            }, (error) => {
                this.pushMessage.emit('global.error.noResponse');
            });
        });
    }

    public getAllGruposEtiquetaPallet(): Promise<any> {
        return new Promise((resolve, reject) => {
            let _filters = {
                tipoConfeccionId: 2
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._adminService.getGruposEtiqueta(_filters).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.lista.length > 0) {
                    this.allGrupoEtiquetasPallet = resp.lista;
                }
                setTimeout(resolve, 1);
            }, (error) => {
                this.pushMessage.emit('global.error.noResponse');
            });
        });
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid) {
            const updateGrupoEtiquetaCaja = {
                licenciaSwId: this.licenciaSwId,
                denominacionId: this.denominacionId,
                almacenId: this.almacenId,
                marcaId: this.marcaId,
                grupoEtiquetaId: this.newEditForm.get('grupoEtiquetasCaja').value ? this.newEditForm.get('grupoEtiquetasCaja').value.id : null
            };
            const updateGrupoEtiquetaPallet = {
                licenciaSwId: this.licenciaSwId,
                denominacionId: this.denominacionId,
                almacenId: this.almacenId,
                marcaId: this.marcaId,
                grupoEtiquetaId: this.newEditForm.get('grupoEtiquetasPallet').value ? this.newEditForm.get('grupoEtiquetasPallet').value.id : null
            };

            if (this.newEditForm.get('grupoEtiquetasCaja').value !== '') {
                this._spinnerService.showSpinner();
                this._adminService.updateGrupoEtiquetasMarca(updateGrupoEtiquetaCaja).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(
                    (resp) => {
                        if (this.newEditForm.get('grupoEtiquetasPallet').value !== '') {
                            this._spinnerService.showSpinner();
                            this._adminService.updateGrupoEtiquetasMarca(updateGrupoEtiquetaPallet).toPromise().finally(() => {
                                this._spinnerService.hideSpinner();
                            }).then(
                                (resp) => {
                                    this.refresh.emit(true);
                                    this.editableChanged.emit(false);
                                    this.newEditForm.disable();
                                    this.disabledCaja.next(true);
                                    this.disabledPallet.next(true);
                                    this.pushMessage.emit('global.success.itemUpdated');
                                },
                                (error) => {
                                    this.showError = true;
                                    this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                                }
                            );
                        } else if (this.grupoEtiquetaIdPallet) {
                            const grupoEtiquetasDelete = {
                                grupoEtiquetaId: this.grupoEtiquetaIdPallet,
                                licenciaSwId: this.licenciaSwId,
                                almacenId: this.almacenId,
                                denominacionId: this.denominacionId,
                                marcaId: this.marcaId
                            };
                            this._spinnerService.showSpinner();
                            this._adminService.deleteGrupoEtiquetasMarca(grupoEtiquetasDelete).toPromise().finally(() => {
                                this._spinnerService.hideSpinner();
                            }).then(() => {
                                this.refresh.emit(true);
                                this.editableChanged.emit(false);
                                this.newEditForm.disable();
                                this.disabledCaja.next(true);
                                this.disabledPallet.next(true);
                                this.pushMessage.emit('global.success.itemDeleted');
                            });
                        } else {
                            this.refresh.emit(true);
                            this.editableChanged.emit(false);
                            this.newEditForm.disable();
                            this.disabledCaja.next(true);
                            this.disabledPallet.next(true);
                            this.pushMessage.emit('global.success.itemUpdated');
                        }
                    },
                    (error) => {
                        this.showError = true;
                        this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                    }
                );
            } else if (this.grupoEtiquetaIdCaja) {
                const grupoEtiquetasDelete = {
                    grupoEtiquetaId: this.grupoEtiquetaIdCaja,
                    licenciaSwId: this.licenciaSwId,
                    almacenId: this.almacenId,
                    denominacionId: this.denominacionId,
                    marcaId: this.marcaId
                };
                this._spinnerService.showSpinner();
                this._adminService.deleteGrupoEtiquetasMarca(grupoEtiquetasDelete).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    if (this.newEditForm.get('grupoEtiquetasPallet').value !== '') {
                        this._spinnerService.showSpinner();
                        this._adminService.updateGrupoEtiquetasMarca(updateGrupoEtiquetaPallet).toPromise().finally(() => {
                            this._spinnerService.hideSpinner();
                        }).then(
                            (resp) => {
                                this.refresh.emit(true);
                                this.editableChanged.emit(false);
                                this.newEditForm.disable();
                                this.disabledCaja.next(true);
                                this.disabledPallet.next(true);
                                this.pushMessage.emit('global.success.itemUpdated');
                            },
                            (error) => {
                                this.showError = true;
                                this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                            }
                        );
                    } else if (this.grupoEtiquetaIdPallet) {
                        const grupoEtiquetasDelete = {
                            grupoEtiquetaId: this.grupoEtiquetaIdPallet,
                            licenciaSwId: this.licenciaSwId,
                            almacenId: this.almacenId,
                            denominacionId: this.denominacionId,
                            marcaId: this.marcaId
                        };
                        this._spinnerService.showSpinner();
                        this._adminService.deleteGrupoEtiquetasMarca(grupoEtiquetasDelete).toPromise().finally(() => {
                            this._spinnerService.hideSpinner();
                        }).then(() => {
                            this.refresh.emit(true);
                            this.editableChanged.emit(false);
                            this.newEditForm.disable();
                            this.disabledCaja.next(true);
                            this.disabledPallet.next(true);
                            this.pushMessage.emit('global.success.itemDeleted');
                        });
                    } else {
                        this.refresh.emit(true);
                        this.editableChanged.emit(false);
                        this.newEditForm.disable();
                        this.disabledCaja.next(true);
                        this.disabledPallet.next(true);
                        this.pushMessage.emit('global.success.itemUpdated');
                    }
                });
            } else if (this.newEditForm.get('grupoEtiquetasPallet').value !== '') {
                this._spinnerService.showSpinner();
                this._adminService.updateGrupoEtiquetasMarca(updateGrupoEtiquetaPallet).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(
                    (resp) => {
                        this.refresh.emit(true);
                        this.editableChanged.emit(false);
                        this.newEditForm.disable();
                        this.disabledCaja.next(true);
                        this.disabledPallet.next(true);
                        this.pushMessage.emit('global.success.itemUpdated');
                    },
                    (error) => {
                        this.showError = true;
                        this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                    }
                );
            } else if (this.grupoEtiquetaIdPallet) {
                const grupoEtiquetasDelete = {
                    grupoEtiquetaId: this.grupoEtiquetaIdPallet,
                    licenciaSwId: this.licenciaSwId,
                    almacenId: this.almacenId,
                    denominacionId: this.denominacionId,
                    marcaId: this.marcaId
                };
                this._spinnerService.showSpinner();
                this._adminService.deleteGrupoEtiquetasMarca(grupoEtiquetasDelete).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(() => {
                    this.refresh.emit(true);
                    this.editableChanged.emit(false);
                    this.newEditForm.disable();
                    this.disabledCaja.next(true);
                    this.disabledPallet.next(true);
                    this.pushMessage.emit('global.success.itemUpdated');
                });
            } else {
                this.refresh.emit(true);
                this.editableChanged.emit(false);
                this.newEditForm.disable();
                this.disabledCaja.next(true);
                this.disabledPallet.next(true);
                this.pushMessage.emit('global.success.itemUpdated');
            }
        }
    }

    public cancel() {
        this.editableChanged.emit(false);
        this.disabledPallet.next(true);
        this.disabledCaja.next(false);
    }

    public edit() {
        this.newEditForm.get('grupoEtiquetasCaja').enable();
        this.newEditForm.get('grupoEtiquetasPallet').enable();
        this.disabledCaja.next(false);
        this.disabledPallet.next(false);
        this.editableChanged.emit(true);
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.pushMessage.emit('global.error.required');
        }
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }
}